import React from "react";
import './_static/BoolFilter.css';

function BoolFilter(props) {
    return (
        <select className="boolFilter" name={props.name} onChange={props.onChange} value={props.value}>
            <option value="">---------</option>
            <option value="true">Áno</option>
            <option value="false">Nie</option>
        </select>
    )
}

export default BoolFilter
